import { useEffect, useState } from 'react';
import { getOwnerIdFromCache } from '../utils/getOwnerIdFromCache';
export function useOwnerId({
  userId
}) {
  const [ownerId, setOwnerId] = useState(null);
  useEffect(() => {
    getOwnerIdFromCache({
      userId
    }).then(result => {
      setOwnerId(result);
    }).catch(() => {
      setOwnerId(0);
    });
  }, [userId]);
  return {
    ownerId
  };
}